import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbDateParserFormatter, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../Model/Common/common.service';
import { EmployeeRegistrationService } from '../../../Model/EmployeeRegistration/employee-registration.service';
import { SessionService } from '../../../Util/Session/session.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ComboService } from '../../../Model/Combo/combo.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import moment from 'moment';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';

@Component({
  selector: 'app-register-excel-filter',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule, NgbDropdownModule,NgbDatepickerModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './register-excel-filter.component.html',
  styleUrl: './register-excel-filter.component.scss'
})
export class RegisterExcelFilterComponent {
  @Input() RegistrationType: string = '';
  @Input() EmpType: string = '';
  
  isDisabled: boolean = false;
  Branchs = [] as any;
  Filter = {
    SelectType: "D",
    BranchID: null,
    LoginUserID: null,
    EmpType: '',
    FromDate: null as any,
    FromDateObj: null as any,
    ToDate: null as any,
    ToDateObj: null as any,
    IncludeDate: false,
    RegistrationType:null as any
  }

  constructor(
    private toast: ToastService,
    private activeModal: NgbActiveModal,
    private employeeRegistration: EmployeeRegistrationService,
    protected common: CommonService,
    private session: SessionService,
    private combo: ComboService,
    private dateFormat: CustomDateParserFormatter,
    private tooltip: TooltipService,
  ) {}

  ngOnInit() {
    this.Filter.RegistrationType = this.RegistrationType;
    this.Filter.EmpType = this.EmpType;
    this.Filter.LoginUserID = this.session.GetUserDetails().UserId;
    this.ComboLoad('Branch');
  }

  Verification(form: any) {
    if (form.valid) {
      this.Confirm();
    } else {
      form.submitted = true;
    }
  }

  Confirm() {
    if (!this.Filter.IncludeDate || (this.Filter.IncludeDate && (moment(this.dateFormat.format(this.Filter.ToDateObj),'DD MMM YYYY').isSameOrAfter(moment(this.dateFormat.format(this.Filter.FromDateObj),'DD MMM YYYY'))))) {
      if(this.Filter.IncludeDate){
        this.Filter.FromDate = this.dateFormat.format(this.Filter.FromDateObj);
        this.Filter.ToDate = this.dateFormat.format(this.Filter.ToDateObj);
      }
      this.activeModal.close(this.Filter);  
    } else {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    }
  }

  close() {
    this.activeModal.close();
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ComboLoad({
      'Combotype': Combotype, 'BranchId': 0, 'ClientId': 0, 'SiteId': 0, 'DesignationId': 0, 'EmpType': null, 'StateId': 0, 'DistrictId': 0, 'EmpMasterID': this.Filter.LoginUserID
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          if (response.ComboLoad) {
            this.Branchs = response.ComboLoad;
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}
